
import React, { useState } from 'react';
import { FaCheck } from "react-icons/fa";
import './LandingPricing.css';

const LandingPricing = ({ offers, onRegisterButtonClicked }) => {
    const [showAll, setShowAll] = useState(false);

    // Initial visible offers (Free, Starter, Boost)
    const visibleOffers = showAll ? offers : offers.slice(0, 3);

    return (
        <section className="landing-pricing-section">
            <div className="pricing-header">
                <h2 className="section-title">Des tarifs simples. <br /> Rentabilité immédiate.</h2>
                <p className="section-subtitle">Commencez gratuitement. Évoluez quand vous gagnez.</p>
            </div>

            <div className="pricing-grid">
                {visibleOffers.map((offer, index) => {
                    const isBoost = offer.keyname === 'boost'; // Highlight popular offering
                    return (
                        <div key={offer.keyname} className={`pricing-card-v2 ${isBoost ? 'highlighted' : ''}`}>
                            {isBoost && <div className="popular-badge">Populaire</div>}
                            <div className="pc-header">
                                <h3 className="pc-title">{offer.title}</h3>
                                <div className="pc-price">
                                    {offer.pricingElement}
                                </div>
                            </div>

                            <ul className="pc-features">
                                {offer.featuresElements.map((feat, i) => {
                                    // Strip the "✓ " checkmark if present
                                    const cleanFeat = feat.replace(/^✓\s*/, '');
                                    return (
                                        <li key={i}>
                                            <span className="feat-icon"><FaCheck /></span>
                                            <span dangerouslySetInnerHTML={{ __html: cleanFeat }} className="feat-text" />
                                        </li>
                                    );
                                })}
                            </ul>

                            <button
                                className={`pc-button ${isBoost ? 'primary' : 'secondary'}`}
                                onClick={onRegisterButtonClicked}
                            >
                                {offer.pricing === 0 ? "Commencer gratuitement" : "Choisir cette offre"}
                            </button>
                        </div>
                    );
                })}
            </div>

            <div className="pricing-more-toggle">
                <button
                    className="btn-text-only"
                    onClick={() => setShowAll(!showAll)}
                >
                    {showAll ? "Voir moins d'offres" : "Voir les offres Agence & Superstar (Gros volumes)"}
                </button>
            </div>

            {offers.some(offer => offer.commissionRate > 0) && (
                <p className="pricing-note">* Commission HT sur le prix des médias envoyés aux fans.</p>
            )}
        </section>
    );
};

export default LandingPricing;
